{
  "el": {
    "phase": {
      "attributes": {
        "end_date": "Ημερομηνία λήξης",
        "internal_note": "Εσωτερική σημείωση φάσης",
        "name": "Όνομα",
        "start_date": "Ημερομηνία έναρξης"
      },
      "labels": {
        "phase": "Καμία φάση | Μία φάση | {count} φάσεις"
      },
      "toasts": {
        "create": "Η φάση δημιουργήθηκε",
        "delete": "Η φάση διαγράφηκε",
        "update": "Η φάση ενημερώθηκε"
      },
      "validation": {
        "needName": "Ο τίτλος είναι υποχρεωτικός",
        "needNumber": "Πρέπει να είναι αριθμός (π.χ. 85)"
      }
    }
  }
}
